import { getClosestElement } from '../Utility/Dom'

class CourseDatesToggle {
  public init(): void {
    document.addEventListener('click', (event): void => {
      const target = event.target as HTMLElement | null
      const toggle = getClosestElement(target, 'course-dates-toggle')
        ?? getClosestElement(target, 'course-content-toggle')
      if (!(toggle instanceof HTMLButtonElement)) return

      const panel = document.getElementById(toggle.getAttribute('aria-controls') ?? '')
      if (!panel) return

      const isOpen = toggle.getAttribute('aria-expanded') === 'true'
      toggle.setAttribute('aria-expanded', String(!isOpen))
      panel.hidden = isOpen
    })
  }
}

const courseDatesToggle = new CourseDatesToggle()
courseDatesToggle.init()
